import api from '../api/client'
import { DEFAULT_ADMIN_APPLICATION_CODE, type ApplicationCode } from '../constants/applications'
import { toApiRequestError } from './apiErrors'

export const ADMIN_AUTH_APPLICATION_CODE: ApplicationCode = DEFAULT_ADMIN_APPLICATION_CODE

export type AdminLoginStartRequest = {
  email: string
  password: string
}

export type AdminLoginStartResponse = {
  otp_required: boolean
  detail?: string
  code?: string
}

export type ForgotPasswordRequest = {
  email: string
  applicationCode?: ApplicationCode
}

export type ResetPasswordRequest = {
  email: string
  token: string
  new_password: string
  confirm_password: string
  applicationCode?: ApplicationCode
}

export async function startAdminLogin(
  payload: AdminLoginStartRequest,
): Promise<AdminLoginStartResponse> {
  try {
    const { data } = await api.post<AdminLoginStartResponse>('/api/core/admin/login/start/', {
      email: payload.email,
      password: payload.password,
      application_code: ADMIN_AUTH_APPLICATION_CODE,
    })
    return data
  } catch (error) {
    throw toApiRequestError(error, 'Unable to start admin login.')
  }
}

export async function requestPasswordReset(payload: ForgotPasswordRequest) {
  try {
    const { data } = await api.post('/api/core/forgot-password/', {
      email: payload.email,
      application_code: payload.applicationCode || ADMIN_AUTH_APPLICATION_CODE,
    })
    return data
  } catch (error) {
    throw toApiRequestError(error, 'Unable to request password reset.')
  }
}

export async function resetPassword(payload: ResetPasswordRequest) {
  try {
    const { data } = await api.post('/api/core/reset-password/', {
      email: payload.email,
      token: payload.token,
      new_password: payload.new_password,
      confirm_password: payload.confirm_password,
      application_code: payload.applicationCode || ADMIN_AUTH_APPLICATION_CODE,
    })
    return data
  } catch (error) {
    throw toApiRequestError(error, 'Unable to reset password.')
  }
}

export function formatAdminAuthError(error: unknown, fallback: string): string {
  const normalized = toApiRequestError(error, fallback)

  if (normalized.isDomainRestriction) {
    return 'Access is restricted to approved LWEGATECH staff domains.'
  }

  return normalized.message || fallback
}

